<template>
  <div class="mc_top" :style="num==2||num==4||num==7?'border:none;':''">
    <div class="left">
      <p class="p1"></p>
      <p class="p2">{{title}}</p>
      <p style="display: inline-block" v-if="num==3||num==5||num==6">
        <el-popover placement="bottom" trigger="hover" popper-class="common-introduce-popover">
          {{content}}
          <div slot="reference">
            <span class="icon-doubt iconfont" style="color: #909399"></span>
          </div>
        </el-popover>
      </p>
    </div>
    <div class="rightbtn">
      <el-button @click="$parent.morePop(num)" size="small" icon="iconfont icon-gengduo">更多</el-button>
      <el-button @click="$parent.exportList(num)" size="small" icon="iconfont icon-daochu">导出</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "dialogHeader",
    props: ["title", "num", "content"],
    methods: {
      
    },
  };
</script>

<style lang="scss" scoped>
  .mc_top {
    margin: 0 24px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    height: 54px;
    border-bottom: 1px solid #f0eef3;

    .left {
      display: flex;
      align-items: center;
    }

    .p1 {
      width: 4px;
      height: 16px;
      background: #5a2df5;
      border-radius: 1px;
      margin-right: 8px;
    }

    .p2 {
      color: #3b3946;
    }

    .rightbtn {
      display: flex;
      margin-left: auto;

      ul {
        cursor: pointer;
        width: 68px;
        height: 28px;
        background: rgba(255, 255, 255, 0);
        border-radius: 4px;
        border: 1px solid #5a2df5;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5a2df5;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 14px;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  ::v-deep( .el-button) {
    width: 68px;
    height: 28px;
    border-color: #5a2df5;
    color: #5a2df5;
  }

  ::v-deep( .iconfont) {
    margin-left: 4px;
  }

  .bn {
    border-bottom: none;
  }
</style>
<style lang="scss">
  .common-introduce-popover{
    width: 254px;
  }
</style>